module.exports = __webpack_public_path__ + "sansg/img/TB1EBxZrwoQMeJjy0FoXXcShVXa-1127-508.5e688ffb.png";